import { PlatformPrefixes } from './consts'
import { IBalanceCurrency } from './types'

import { getPlatformIcon, IconTypes } from '@/common/getPlatformIcon'
import { getNumWithDelimiter } from '@/common/utils'
import { IComboBoxOption } from '@/components/ComboBox'
import { NetworkNames, TelegramSubNames, UNDERSCORE_WITH_DIGITS_REGEX } from '@/const'
import { AccountCurrencies } from '@/store/adaccounts/types'
import { IBalance } from '@/store/budget/types'
import { CurrencySign, UserWorkflow } from '@/store/user/types'
import { NetworkExtraTypes, TelegramExtraTypes } from '@/types'

export const getCurrencyByType = (value: string): CurrencySign => {
  const types: { [key: string]: CurrencySign } = {
    balance_usd: CurrencySign.USD,
    balance_eur: CurrencySign.EUR,
    fb: CurrencySign.USD,
    tk: CurrencySign.USD,
    tg: CurrencySign.EUR,
    TON: CurrencySign.TON,
  }

  return types[value.replace(UNDERSCORE_WITH_DIGITS_REGEX, '')]
}

const getIconType = (value: string): IconTypes => {
  const types: { [key: string]: IconTypes } = {
    balance_usd: IconTypes.BALANCE_USD,
    balance_eur: IconTypes.BALANCE_EUR,
    fb: IconTypes.FACEBOOK,
    tk: IconTypes.TIKTOK,
    tg: IconTypes.TELEGRAM,
  }

  return types[value.replace(UNDERSCORE_WITH_DIGITS_REGEX, '')]
}

export const transformBalances = (balances: IBalance[]): [IComboBoxOption[], IBalanceCurrency[]] => {
  const accounts = balances.map((balance) => {
    const currency = getCurrencyByType(balance.id)
    const isTGAdsAccount = balance.id.includes(PlatformPrefixes.telegram_eur)
    const isPartnerWorkflow = balance.workflow === UserWorkflow.partner
    const isTonTelegram = balance.currency === AccountCurrencies.TON
    const isAlternativeIcon = isPartnerWorkflow || isTGAdsAccount

    return {
      icon: getPlatformIcon(getIconType(balance.id), isAlternativeIcon, isTonTelegram),
      value: balance.id,
      label:
        isNaN(Number(balance?.amount)) || isTGAdsAccount
          ? ''
          : `${currency} ${getNumWithDelimiter(balance?.amount?.toString() ?? '')}`,
      subLabel: balance.name,
    }
  })

  const currencies = balances.map((balance) => ({
    [balance.id]: balance.currency,
  }))

  return [accounts, currencies]
}

export const transformAccountsTo = (accounts: (NetworkExtraTypes & TelegramExtraTypes)[]): IComboBoxOption[] => {
  const result: IComboBoxOption[] = accounts.map((item) => ({
    value: item,
    icon: getPlatformIcon(item),
    label: { ...NetworkNames, ...TelegramSubNames }[item],
  }))

  return result
}
